<wbo-search-page>
    <wbo-search-form>
        <wbo-search-form-fields>
            <wbo-search-form-field field="invoiceNo">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field field="supplierInvoice">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
        </wbo-search-form-fields>
        <wbo-search-form-extended-fields>
            <wbo-search-form-field *extendedField="'dateFrom'">
                <wbo-date-search-control></wbo-date-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'dateTo'">
                <wbo-date-search-control></wbo-date-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'supplier'">
                <wbo-supplier-multi-select-search-control></wbo-supplier-multi-select-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'status'">
                <wbo-single-select-search-control>
                    <wbo-select-options>
                        <wbo-select-option value="Pending"
                                           label="wbo.credit-invoice.option.status.pending"></wbo-select-option>
                        <wbo-select-option value="Complete"
                                           label="wbo.credit-invoice.option.status.complete"></wbo-select-option>
                    </wbo-select-options>
                </wbo-single-select-search-control>
            </wbo-search-form-field>
        </wbo-search-form-extended-fields>
    </wbo-search-form>
    <wbo-search-grid>
        <wbo-column field="invoiceNo"></wbo-column>
        <wbo-date-column field="invoiceDate"></wbo-date-column>
        <wbo-column field="supplier"></wbo-column>
        <wbo-column field="status"></wbo-column>
        <wbo-column field="employee"></wbo-column>
        <wbo-date-column field="processedDate"></wbo-date-column>
        <wbo-date-column field="lastUpdated"></wbo-date-column>
        <wbo-actions-search-column>
            <wbo-report-search-action [idColumn]="'invoiceId'"></wbo-report-search-action>
        </wbo-actions-search-column>
    </wbo-search-grid>
</wbo-search-page>
